module.exports = __webpack_public_path__ + "static/media/staff0.df8b2097.png";